import { lang } from '@umu/ukit-lang';
import { IMG_UPLOAD_TYPE } from './interface';

export const tabParams = [
    {
        key: IMG_UPLOAD_TYPE.UPLOAD_SELF,
        tab: lang('从电脑中选择'),
    },
    {
        key: IMG_UPLOAD_TYPE.RECOMMEND_BY_UMU,
        tab: lang('UMU推荐'),
    },
];


export const FILE_MAX_SIZE = 10 * 1024 * 1024;

export const IMG_FILE_ACCEPTS = 'image/png,image/gif,image/jpg,image/jpeg';

